import SyncIcon from '@mui/icons-material/Sync';
import SyncDisabledIcon from '@mui/icons-material/SyncDisabled';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import { SvgIconProps } from '@mui/material';

import { SyncState } from '../types/SyncState';

const SyncingIcon = ({ sx, ...props }: SvgIconProps) => (
  <SyncIcon
    {...props}
    sx={{
      animation: (theme) => `rotate ${theme.transitions.duration.standard * 10}ms linear infinite`,
      '@keyframes rotate': {
        '0%': {
          transform: 'rotate(360deg)',
        },
        '100%': {
          transform: 'rotate(0deg)',
        },
      },
      ...sx,
    }}
  />
);

type Props = SvgIconProps & {
  /** Sync button state */
  state: SyncState;
};

/**
 * Icon for accounting software sync buttons
 * @param props Component props
 * @returns React component
 */
const SyncButtonIcon = ({ state, ...svgIconProps }: Props) => {
  switch (state) {
    case 'connected':
      return <SyncIcon role="presentation" data-state={state} {...svgIconProps} />;
    case 'syncing':
      return <SyncingIcon role="presentation" data-state={state} {...svgIconProps} />;
    case 'error':
      return (
        <SyncProblemIcon role="presentation" data-state={state} color="error" {...svgIconProps} />
      );
    case 'expired':
      return <SyncIcon role="presentation" data-state={state} {...svgIconProps} />;
    case 'disconnected':
      return <SyncDisabledIcon role="presentation" data-state={state} {...svgIconProps} />;
    case 'unset':
      return <SyncDisabledIcon role="presentation" data-state={state} {...svgIconProps} />;
    default:
      return null;
  }
};

export type { Props as SyncButtonIconProps };
export default SyncButtonIcon;
